
const categoriesCheckQuantity = [
  'Шины',
  'Диски',
  'Грузовые шины',
  'Шины на квадроцикл',
  'Шины с пробегом',
  'Грузовые диски',
  'Диски с пробегом',
];

export default {
  name: 'Index',

  head: function () {
    const title = 'Корзина';
    const description = '';

    return this.$seoMetaHelper({
      title: title,
      description: description,

      meta: [
        {
          name: 'og:title', hid: 'og:title', property: 'og:title', content: title,
        },

        { name: 'description', hid: 'metadescription', content: description },
        {
          name: 'og:description', hid: 'og:description', property: 'og:description', content: description,
        },
      ],
    });
  },

  data: function () {
    return {
      selectedCartItems: [],
      selectedServicesList: [],

      checkoutData: {},

      isLoadingCheckoutData: true,
      wasCartChanged: false,

      checkoutDataInterval: null,
    };
  },

  computed: {
    pageTitle: function () {
      if (!this.isLoadCard && !this.cartItems.length) {
        return 'Корзина пуста';
      }
      return 'Корзина';
    },

    breadcrumbs: function () {
      return [
        {
          title: 'Главная',
          path: '/',
        },
        {
          title: 'Корзина',
          path: this.$route.path,
        },
      ];
    },
    cartItems: function () {
      return this.$store.state.cart?.items || [];
    },
    cartItemsProducts: function () {
      return (this.$store.state.cart?.items || []).map((t) => ({
        ...t.product,
        quantity: t.quantity,
      }));
    },

    isFullSelected: function () {
      return Boolean(this.selectedCartItems.length === this.cartItems.length);
    },
    isLoadCard: function () {
      return Boolean(this.isLoadingCheckoutData);
    },
    isVisibleLackQuantityGoods: function () {
      let isError = false;
      this.cartItems.map((cartItem) => {
        const productUnit = (cartItem?.product?.unit || '').replace('/', '');
        const productCategory = cartItem?.product?.category;
        if ((productUnit || '').indexOf('комплект') <= -1 && !!categoriesCheckQuantity.includes(productCategory) && cartItem.quantity < 4) {
          isError = true;
        }
      });

      return isError;
    },

    cartEmptyMessage: function () {
      return this.$store.state.appState?.vars?.['Уведомление для пустой корзины'] || 'Воспользуйтесь поиском или перейдите в каталог товаров';
    },
  },

  components: {
    Breadcrumbs: () => import('~/components/UI/Breadcrumbs'),
    TotalInformation: () => import('~/components/cart/TotalInformation'),
    ProductCard: () => import('~/components/cart/ProductCard'),
    DonForgetAdd: () => import('~/components/cart/DonForgetAdd'),
    AdditionalServices: () => import('~/components/cart/AdditionalServices'),
  },

  watch: {
    cartItems: {
      async handler(prevState, newState) {
        // if (JSON.stringify(prevState) === JSON.stringify(newState)) {
        //   return;
        // }
        if (this.isLoadingCheckoutData) {
          return;
        }
        await this.getCheckoutData();
      },
      deep: true,
    },

    checkoutData: {
      async handler(prevState, newState) {
        if (JSON.stringify(prevState) !== JSON.stringify(newState)) {
          await this.$store.dispatch('cart/getCart');
        }
      },
      deep: true,
    },
  },

  mounted: async function () {
    this.isLoadingCheckoutData = true;
    await this.getCheckoutData();
    this.selectedServicesList = this.$route.query?.services
      ? this.$route.query?.services.split(',')
      : [];

    this.checkoutDataInterval = setInterval(async () => {
      await this.checkCartChange();
    }, 60000);
  },

  beforeDestroy() {
    clearInterval(this.checkoutDataInterval);
  },

  methods: {
    async checkCartChange() {
      if (this.wasCartChanged) {
        clearInterval(this.checkoutDataInterval);
        return;
      }

      const response = await this.$api.agent.transport.get('/checkout/data').then((res) => res.data).catch(() => ({}));

      const checkChange = this.checkoutData.cart.total !== response.cart.total
				|| this.checkoutData.cart.products_count !== response.cart.products_count;

      if (checkChange) {
        this.wasCartChanged = true;
      }
    },

    onShareCart() {
      const products = [...this.cartItems];
      const prod = products.map((t) => `${t.product.id}:${t.quantity}`).join(',');
      const servicesStr = (this.$refs.refAdditionalServices?.getSelectedServices() || []).map((t) => t.slug).join(',');
      const services = servicesStr ? `&services=${servicesStr}` : '';

      if (process.client) {
        const link = `https://${window.location.host}/cart/share?products=${prod}${services}`;
        navigator.clipboard.writeText(link);
        this.$toast.success('Ссылка скопирована');
      }
    },

    getCheckoutData: async function () {
      const response = await this.$api.agent.transport.get('/checkout/data').then((res) => res.data).catch(() => ({}));
      this.checkoutData = response;
      this.isLoadingCheckoutData = false;
    },

    createOrder: async function (body) {
      let selectedServices = this.$refs.refAdditionalServicesMobile?.getSelectedServices() || [];
      if (selectedServices.length <= 0) {
        selectedServices = this.$refs.refAdditionalServices?.getSelectedServices() || [];
      }
      if (selectedServices.length) {
        body.note = [
          body.note,
          `А так же я хочу заказать услуги: ${selectedServices.map((t) => t.label).join(', ')}`,
        ].filter((t) => !!t).join('; <br/>');
      }
      this.$store.commit('loading/setLoading', true);
      const isPaymentOnline = (this.checkoutData?.payments || []).find((t) => t.id === body.PaymentForm.id)?.isOnlineMethod || false;
      const response = await this.$api.agent.transport.post('/checkout/submit', body).then((res) => res.data).catch((err) => {
        if (err?.response?.status === 500) {
          return { error: 'Произошла ошибка при оформлении заказа. Пожалуйста, свяжитесь с нашим консультантом' };
        }

        return { error: err.response?.data?.[0]?.message || '' };
      });
      if (response?.error) {
        this.$toast.error(response?.error);
        this.$store.commit('loading/setLoading', false);
        return null;
      }

      this.$toast.success('Заказ успешно создан');
      this.$yandexMetrika.reachGoal('send_order_cart');
      this.$yandexCommerce('purchase', this.cartItemsProducts, {
        actionFieldId: response.id,
      });
      await this.$store.dispatch('cart/getCart');
      this.$store.commit('loading/setLoading', false);

      if (isPaymentOnline && body?.PaymentForm?.id != 3) {
        window.history.pushState(null, null, `/cart/success/${response.hash}`);
        window.location.href = await this.getLinkPayment(response.hash);
        return;
      }
      this.$router.push(`/cart/success/${response.hash}`);
    },
    getLinkPayment: async function (hash) {
      return await this.$api.agent.transport.post(`checkout/pay/${hash}`, {
        hash,
      }).then((res) => res.data).catch(() => null);
    },

    changeSelected: function (cartItemId) {
      const selectedCartItems = [...this.selectedCartItems];
      const findIndex = selectedCartItems.findIndex((t) => t === cartItemId);
      if (findIndex > -1) {
        selectedCartItems.splice(findIndex, 1);
      } else {
        selectedCartItems.push(cartItemId);
      }
      this.selectedCartItems = selectedCartItems;
    },
    changeFullSelected: function () {
      const isFull = this.selectedCartItems.length === this.cartItems.length;

      let selectedCartItems = [];
      if (!isFull) {
        selectedCartItems = this.cartItems.map((t) => t.id);
      }

      this.selectedCartItems = selectedCartItems;
    },

    removeSelectedCartItems: async function () {
      if (this.selectedCartItems.length <= 0) {
        return;
      }

      await Promise.all(this.selectedCartItems.map(async (itemId) => {
        const cartItem = (this.cartItems || []).find((t) => t.id === itemId);
        const product = cartItem?.product || {};
        await this.$store.dispatch('cart/removeCartItem', itemId);
        this.$yandexCommerce('remove', [{
          ...product,
          quantity: cartItem.quantity,
        }]);
      }));

      this.selectedCartItems = [];
      await this.$store.dispatch('cart/getCart');
      this.$toast.success('Выбранные позиции удалены');
    },
  },
};
